import React, { useEffect, useState } from "react";
import { HashRouter, Switch, Route, Redirect } from "react-router-dom";
import { useQlik } from "../context/Qlik";
import { useFilterBar } from "../context/FilterBar";
import { useLeftBar } from "../context/LeftBar";
import { useConfig } from "../context/Config";
import Overview from "./Overview/Overview";
import ExtraScores from "./ExtraScores/ExtraScores";
import SellOutArea from "./KpiPages/SellOutArea/SellOutArea";
import SellOutGoldenStores from "./GoldenStores/SellOutGoldenStores/SellOutGoldenStores";
import LeftSideMenu from "../components/LeftSideMenu/LeftSideMenu";
import AppLoader from "../components/AppLoader/AppLoader";
import FilterMenu from "../components/FilterMenuNative/FilterMenu";
import Header from "../components/Header/Header";
import "../style.scss";
import PositivacaoArea from "./PositivacaoArea/PositivacaoArea";
import DistribuicaoGoldenStores from "./GoldenStores/Distribuicao/DistribuicaoGoldenStores";
import { Simulador } from "./Simulador";

function Layout() {
  const { qlik, qlikConfig, setActualApp } = useQlik();
  const { filterBarOpened } = useFilterBar();
  const { leftBarOpened } = useLeftBar();
  const { config } = useConfig();
  const [app, setApp] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (qlik) {
      setIsLoading(false);
      const qvfId = process.env.REACT_APP_QVF_ID;
      const tempApp = qlik.openApp(qvfId, qlikConfig);
      window.app = tempApp;
      setApp(tempApp);
      setActualApp(tempApp);
    }
  }, [qlik, qlikConfig, setActualApp]);

  useEffect(() => {
    if (qlik) setTimeout(qlik.resize, 500);
  }, [qlik]);

  return isLoading ? (
    <AppLoader />
  ) : (
    <div
      style={{ left: leftBarOpened && "224px" }}
      className={filterBarOpened ? "appWrapper is-right-opened" : "appWrapper"}
    >
      <div id="expandedWrapper" />
      <HashRouter>
        <LeftSideMenu app={app} config={config} />
        <Header />
        <FilterMenu
          app={app}
          filters={config?.app?.filters || {}}
          config={config}
        />
        <Switch>
          <Route exact path="/">
            <Redirect to="/overview" />
          </Route>
          <Route
            path="/overview"
            exact
            render={() => <Overview app={app} config={config} />}
          />
          <Route
            path="/area/sell-out"
            exact
            render={() => <SellOutArea app={app} config={config} />}
          />
          <Route
            path="/area/positivacao"
            exact
            render={() => <PositivacaoArea app={app} config={config} />}
          />
          <Route
            path="/golden-stores/sell-out"
            exact
            render={() => <SellOutGoldenStores app={app} config={config} />}
          />
          <Route
            path="/golden-stores/distribuicao"
            exact
            render={() => (
              <DistribuicaoGoldenStores app={app} config={config} />
            )}
          />
          <Route
            path="/extra-scores"
            exact
            render={() => <ExtraScores app={app} config={config} />}
          />

          <Route
            path="/simulador"
            exact
            render={() => <Simulador app={app} config={config} />}
          />
        </Switch>
      </HashRouter>
    </div>
  );
}

export default Layout;
